import {AudienceFrequencyEnum} from '@gl/lit/types/journey/audience_frequency.js';
import type FlyScheduleFrequencyInput from './index.js';

export function dispatchChangeEvent(host: FlyScheduleFrequencyInput): void {
  if (!host.isConnected) return;
  const {value, defaultValue} = host.model;
  const eventValue = getValue(value, defaultValue);

  host.dispatchEvent(
    new CustomEvent('frequency:change', {
      bubbles: true,
      cancelable: false,
      composed: true,
      detail: {
        value: eventValue,
      },
    })
  );
}

export function getDefaultFrequencyOptions(): AudienceFrequencyEnum[] {
  return Object.values(AudienceFrequencyEnum);
}

export function normalizeValue<T>(value: T | '', options: T[]): T | '' {
  return value !== '' && options.includes(value) ? value : '';
}

export function getValue<T>(value: T | '', defaultValue: T | ''): T | '' {
  return value !== '' ? value : defaultValue;
}
